module.exports = __webpack_public_path__ + "static/media/customize.0fe5b126.png";